import {translations} from 'locales/translations';
import {__} from 'utils/messages';

export default {
  title: () => __(translations.productionMonitoringRouter.title, 'Production monitoring'),
  calendar: () => __(translations.productionMonitoringRouter.calendar, 'Calendar'),
  listing: () => __(translations.productionMonitoringRouter.listing, 'Listing'),
};
